module.exports = __webpack_public_path__ + "static/media/VotrCrwd.488adf46.svg";